import { render, staticRenderFns } from "./FeedNotification.vue?vue&type=template&id=1d21fb9e&"
import script from "./FeedNotification.vue?vue&type=script&lang=js&"
export * from "./FeedNotification.vue?vue&type=script&lang=js&"
import style0 from "./FeedNotification.vue?vue&type=style&index=0&id=1d21fb9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports